var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImplementation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 727.5,
    height: 643.531,
    viewBox: "0 0 760.5 643.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19228",
    "data-name": "Rectangle 19228",
    width: 83.111,
    height: 83.111,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19228-2",
    "data-name": "Rectangle 19228",
    width: 45.329,
    height: 45.329,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19228-3",
    "data-name": "Rectangle 19228",
    width: 57.163,
    height: 57.163,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19213",
    "data-name": "Rectangle 19213",
    width: 227.865,
    height: 35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19214",
    "data-name": "Rectangle 19214",
    width: 299.822,
    height: 46.053,
    fill: "#1e5a7c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19215",
    "data-name": "Rectangle 19215",
    width: 394.503,
    height: 60.596,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19228-4",
    "data-name": "Rectangle 19228",
    width: 69.641,
    height: 69.641,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19228-5",
    "data-name": "Rectangle 19228",
    width: 43.773,
    height: 43.773,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19215-2",
    "data-name": "Rectangle 19215",
    width: 394.503,
    height: 60.596,
    fill: "#3b414e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19256",
    "data-name": "Rectangle 19256",
    width: 177.903,
    height: 20.17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19257",
    "data-name": "Rectangle 19257",
    width: 81.889,
    height: 18.895,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19261",
    "data-name": "Rectangle 19261",
    width: 140.461,
    height: 19.134,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48868",
    "data-name": "Group 48868",
    transform: "translate(-232.5 -1009.146)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5143",
    "data-name": "Ellipse 5143",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(937 1341)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48867",
    "data-name": "Group 48867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "botA1",
    "data-name": "Group 48848",
    transform: "translate(0 -11)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48845",
    "data-name": "Group 48845",
    transform: "translate(-249.061 375.984)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5144",
    "data-name": "Ellipse 5144",
    cx: 50.787,
    cy: 50.787,
    r: 50.787,
    transform: "translate(594.432 1151.52) rotate(-45)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52389",
    "data-name": "Path 52389",
    d: "M9.338,58.436a49.1,49.1,0,1,0,49.1-49.1,49.1,49.1,0,0,0-49.1,49.1",
    transform: "translate(607.819 1093.083)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52390",
    "data-name": "Path 52390",
    d: "M28.209,239.909h-.028a.519.519,0,0,1-.491-.545,46.068,46.068,0,0,1,.666-5.758.519.519,0,1,1,1.021.184,45.151,45.151,0,0,0-.651,5.627.519.519,0,0,1-.517.492",
    transform: "translate(592.786 909.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52391",
    "data-name": "Path 52391",
    d: "M54.61,53.308a.519.519,0,0,1-.462-.752A45.65,45.65,0,0,1,95.1,27.343a46.207,46.207,0,0,1,8.269.745.518.518,0,1,1-.186,1.02A45.222,45.222,0,0,0,95.1,28.38,44.618,44.618,0,0,0,55.074,53.023a.519.519,0,0,1-.464.285",
    transform: "translate(571.159 1078.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48811",
    "data-name": "Group 48811",
    transform: "translate(625.77 1111.033)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48810",
    "data-name": "Group 48810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48809",
    "data-name": "Group 48809",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52392",
    "data-name": "Path 52392",
    d: "M140.071,98.515A41.556,41.556,0,1,1,98.516,56.959a41.556,41.556,0,0,1,41.556,41.556",
    transform: "translate(-56.96 -56.959)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52393",
    "data-name": "Path 52393",
    d: "M208.332,139.526c0,7.28,5.9,15.138,13.181,15.138s13.181-7.859,13.181-15.138-5.9-12.444-13.181-12.444-13.181,5.164-13.181,12.444",
    transform: "translate(444.813 996.633)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52394",
    "data-name": "Path 52394",
    d: "M145.558,306.6a7.755,7.755,0,0,0-4.97,9.4l1.333,4.915a7.789,7.789,0,0,0,7.517,5.75h32.176a7.788,7.788,0,0,0,7.418-5.415l1.732-5.412a7.78,7.78,0,0,0-4.7-9.681,54.392,54.392,0,0,0-18.829-3.316,68.562,68.562,0,0,0-21.676,3.758",
    transform: "translate(500.531 852.663)",
    fill: "#3eb6fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5147",
    "data-name": "Ellipse 5147",
    transform: "translate(362 1544)",
    fill: "#00b906",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    "data-name": "Icon awesome-check",
    d: "M6.114,17.736l-5.85-5.85a.9.9,0,0,1,0-1.273L1.536,9.341a.9.9,0,0,1,1.273,0L6.75,13.282l8.441-8.441a.9.9,0,0,1,1.273,0l1.273,1.273a.9.9,0,0,1,0,1.273L7.386,17.736A.9.9,0,0,1,6.114,17.736Z",
    transform: "translate(371.5 1551.211)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    keyTimes: "0;0.12;0.78;1",
    dur: "4.2s",
    begin: "1.6s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.33 0 0.67 1; 0 0 1 1; 0.25 0.1 0.25 1"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "sum",
    values: "0,0; 0,12; 0,20; 0,26",
    keyTimes: "0;0.5;0.85;1",
    dur: "4.2s",
    begin: "1.6s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.42 0 1 1; 0 0 1 1; 0.25 0.1 0.25 1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "botA2",
    "data-name": "Group 48850",
    transform: "translate(32.651 118.651)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48845-2",
    "data-name": "Group 48845",
    transform: "translate(345.371 1455.68)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5144-2",
    "data-name": "Ellipse 5144",
    cx: 27.699,
    cy: 27.699,
    r: 27.699,
    transform: "translate(0 39.173) rotate(-45)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52389-2",
    "data-name": "Path 52389",
    d: "M9.338,36.116A26.778,26.778,0,1,0,36.116,9.338,26.778,26.778,0,0,0,9.338,36.116",
    transform: "translate(3.056 3.056)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52390-2",
    "data-name": "Path 52390",
    d: "M27.973,236.849h-.015a.283.283,0,0,1-.268-.3,25.127,25.127,0,0,1,.363-3.14.283.283,0,1,1,.557.1,24.626,24.626,0,0,0-.355,3.069.283.283,0,0,1-.282.268",
    transform: "translate(-13.485 -198.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52391-2",
    "data-name": "Path 52391",
    d: "M54.375,41.5a.283.283,0,0,1-.252-.41A24.9,24.9,0,0,1,76.456,27.343a25.2,25.2,0,0,1,4.51.406.283.283,0,1,1-.1.556,24.664,24.664,0,0,0-4.409-.4,24.335,24.335,0,0,0-21.829,13.44.283.283,0,0,1-.253.156",
    transform: "translate(-37.283 -13.173)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48811-2",
    "data-name": "Group 48811",
    transform: "translate(17.092 17.092)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48810-2",
    "data-name": "Group 48810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48809-2",
    "data-name": "Group 48809",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52392-2",
    "data-name": "Path 52392",
    d: "M102.289,79.624A22.665,22.665,0,1,1,79.625,56.959a22.665,22.665,0,0,1,22.665,22.665",
    transform: "translate(-56.96 -56.959)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52393-2",
    "data-name": "Path 52393",
    d: "M208.332,133.869c0,3.97,3.218,8.256,7.189,8.256s7.189-4.286,7.189-8.256-3.219-6.787-7.189-6.787-7.189,2.817-7.189,6.787",
    transform: "translate(-176.31 -103.074)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52394-2",
    "data-name": "Path 52394",
    d: "M143.174,304.887a4.23,4.23,0,0,0-2.711,5.128l.727,2.68a4.248,4.248,0,0,0,4.1,3.136h17.549a4.248,4.248,0,0,0,4.046-2.953l.944-2.952a4.244,4.244,0,0,0-2.564-5.28A29.665,29.665,0,0,0,155,302.837a37.394,37.394,0,0,0-11.822,2.05",
    transform: "translate(-115 -261.493)",
    fill: "#3eb6fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5147-2",
    "data-name": "Ellipse 5147",
    transform: "translate(354.349 1504.349)",
    fill: "#00b906",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-2",
    "data-name": "Icon awesome-check",
    d: "M3.334,11.754.144,8.564a.491.491,0,0,1,0-.694l.694-.694a.491.491,0,0,1,.694,0L3.681,9.325l4.6-4.6a.491.491,0,0,1,.694,0l.694.694a.491.491,0,0,1,0,.694L4.029,11.754A.491.491,0,0,1,3.334,11.754Z",
    transform: "translate(359.622 1505.702)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    keyTimes: "0;0.12;0.78;1",
    dur: "4.2s",
    begin: "1.9s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.33 0 0.67 1; 0 0 1 1; 0.25 0.1 0.25 1"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "sum",
    values: "0,0; 0,12; 0,20; 0,26",
    keyTimes: "0;0.5;0.85;1",
    dur: "4.2s",
    begin: "1.6s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.42 0 1 1; 0 0 1 1; 0.25 0.1 0.25 1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "botA3",
    "data-name": "Group 48849",
    transform: "translate(274.595 13.073)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "botA3_rot",
    transform: "rotate(7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48845-3",
    "data-name": "Group 48845",
    transform: "translate(345.371 1455.68)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5144-3",
    "data-name": "Ellipse 5144",
    cx: 34.931,
    cy: 34.931,
    r: 34.931,
    transform: "translate(0 49.399) rotate(-45)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52389-3",
    "data-name": "Path 52389",
    d: "M9.338,43.107A33.769,33.769,0,1,0,43.107,9.338,33.769,33.769,0,0,0,9.338,43.107",
    transform: "translate(6.292 6.292)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52390-3",
    "data-name": "Path 52390",
    d: "M28.047,237.807h-.019a.357.357,0,0,1-.338-.375,31.684,31.684,0,0,1,.458-3.96.357.357,0,1,1,.7.127,31.054,31.054,0,0,0-.448,3.87.357.357,0,0,1-.356.338",
    transform: "translate(-9.777 -189.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52391-3",
    "data-name": "Path 52391",
    d: "M54.448,45.2a.357.357,0,0,1-.318-.517A31.4,31.4,0,0,1,82.294,27.343a31.78,31.78,0,0,1,5.688.512.357.357,0,1,1-.128.7,31.1,31.1,0,0,0-5.56-.5A30.688,30.688,0,0,0,54.767,45.005a.357.357,0,0,1-.319.2",
    transform: "translate(-32.895 -9.474)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48811-3",
    "data-name": "Group 48811",
    transform: "translate(21.554 21.553)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48810-3",
    "data-name": "Group 48810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48809-3",
    "data-name": "Group 48809",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52392-3",
    "data-name": "Path 52392",
    d: "M114.123,85.54A28.581,28.581,0,1,1,85.541,56.959,28.581,28.581,0,0,1,114.123,85.54",
    transform: "translate(-56.96 -56.959)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52393-3",
    "data-name": "Path 52393",
    d: "M208.332,135.641c0,5.007,4.059,10.412,9.065,10.412s9.066-5.405,9.066-10.412-4.059-8.559-9.066-8.559-9.065,3.552-9.065,8.559",
    transform: "translate(-167.95 -96.806)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52394-3",
    "data-name": "Path 52394",
    d: "M143.92,305.422a5.334,5.334,0,0,0-3.418,6.466l.917,3.38a5.357,5.357,0,0,0,5.17,3.954h22.13a5.357,5.357,0,0,0,5.1-3.724l1.191-3.722a5.351,5.351,0,0,0-3.233-6.658,37.411,37.411,0,0,0-12.951-2.281,47.156,47.156,0,0,0-14.908,2.585",
    transform: "translate(-108.392 -250.7)",
    fill: "#3eb6fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5147-3",
    "data-name": "Ellipse 5147",
    transform: "translate(356.808 1516.425)",
    fill: "#00b906",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.724,
    cy: 12.724,
    r: 12.724,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.724,
    cy: 12.724,
    r: 11.224,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-3",
    "data-name": "Icon awesome-check",
    d: "M4.2,13.628.181,9.6a.619.619,0,0,1,0-.875l.875-.875a.619.619,0,0,1,.875,0l2.71,2.71,5.806-5.805a.619.619,0,0,1,.875,0l.875.875a.619.619,0,0,1,0,.875L5.08,13.628A.619.619,0,0,1,4.2,13.628Z",
    transform: "translate(363.342 1519.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48845-3",
    "data-name": "Group 48845",
    transform: "translate(345.371 1455.68)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5144-3",
    "data-name": "Ellipse 5144",
    cx: 34.931,
    cy: 34.931,
    r: 34.931,
    transform: "translate(0 49.399) rotate(-45)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52389-3",
    "data-name": "Path 52389",
    d: "M9.338,43.107A33.769,33.769,0,1,0,43.107,9.338,33.769,33.769,0,0,0,9.338,43.107",
    transform: "translate(6.292 6.292)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52390-3",
    "data-name": "Path 52390",
    d: "M28.047,237.807h-.019a.357.357,0,0,1-.338-.375,31.684,31.684,0,0,1,.458-3.96.357.357,0,1,1,.7.127,31.054,31.054,0,0,0-.448,3.87.357.357,0,0,1-.356.338",
    transform: "translate(-9.777 -189.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52391-3",
    "data-name": "Path 52391",
    d: "M54.448,45.2a.357.357,0,0,1-.318-.517A31.4,31.4,0,0,1,82.294,27.343a31.78,31.78,0,0,1,5.688.512.357.357,0,1,1-.128.7,31.1,31.1,0,0,0-5.56-.5A30.688,30.688,0,0,0,54.767,45.005a.357.357,0,0,1-.319.2",
    transform: "translate(-32.895 -9.474)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48811-3",
    "data-name": "Group 48811",
    transform: "translate(21.554 21.553)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48810-3",
    "data-name": "Group 48810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48809-3",
    "data-name": "Group 48809",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52392-3",
    "data-name": "Path 52392",
    d: "M114.123,85.54A28.581,28.581,0,1,1,85.541,56.959,28.581,28.581,0,0,1,114.123,85.54",
    transform: "translate(-56.96 -56.959)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52393-3",
    "data-name": "Path 52393",
    d: "M208.332,135.641c0,5.007,4.059,10.412,9.065,10.412s9.066-5.405,9.066-10.412-4.059-8.559-9.066-8.559-9.065,3.552-9.065,8.559",
    transform: "translate(-167.95 -96.806)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52394-3",
    "data-name": "Path 52394",
    d: "M143.92,305.422a5.334,5.334,0,0,0-3.418,6.466l.917,3.38a5.357,5.357,0,0,0,5.17,3.954h22.13a5.357,5.357,0,0,0,5.1-3.724l1.191-3.722a5.351,5.351,0,0,0-3.233-6.658,37.411,37.411,0,0,0-12.951-2.281,47.156,47.156,0,0,0-14.908,2.585",
    transform: "translate(-108.392 -250.7)",
    fill: "#3eb6fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5147-3",
    "data-name": "Ellipse 5147",
    transform: "translate(356.808 1516.425)",
    fill: "#00b906",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.724,
    cy: 12.724,
    r: 12.724,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.724,
    cy: 12.724,
    r: 11.224,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-3",
    "data-name": "Icon awesome-check",
    d: "M4.2,13.628.181,9.6a.619.619,0,0,1,0-.875l.875-.875a.619.619,0,0,1,.875,0l2.71,2.71,5.806-5.805a.619.619,0,0,1,.875,0l.875.875a.619.619,0,0,1,0,.875L5.08,13.628A.619.619,0,0,1,4.2,13.628Z",
    transform: "translate(363.342 1519.956)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    keyTimes: "0;0.12;0.78;1",
    dur: "4.2s",
    begin: "2.2s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.33 0 0.67 1; 0 0 1 1; 0.25 0.1 0.25 1"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "sum",
    values: "0,0; 0,12; 0,20; 0,26",
    keyTimes: "0;0.5;0.85;1",
    dur: "4.2s",
    begin: "2.2s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.42 0 1 1; 0 0 1 1; 0.25 0.1 0.25 1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48788",
    "data-name": "Group 48788",
    transform: "translate(180.445 1015.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52370",
    "data-name": "Path 52370",
    d: "M515.477,1107.467c-64.323,0-116.467,8.917-116.467,19.914a3.3,3.3,0,0,0,.06.635l.6,1.492,7.642,19.021,15.668,39c21.881,8.048,55.19,12.991,92.5,12.991s70.616-4.944,92.5-12.991l15.668-39,7.642-19.021.6-1.492a3.3,3.3,0,0,0,.06-.635c0-11-52.143-19.914-116.467-19.914m-107.351,24.968c.863.375,1.826.758,2.9,1.148-1.071-.389-2.034-.773-2.9-1.148",
    transform: "translate(-261.282 -725.197)",
    fill: "#2d5a87"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48777",
    "data-name": "Group 48777",
    transform: "translate(140.262 384.684)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48776",
    "data-name": "Group 48776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48775",
    "data-name": "Group 48775",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52371",
    "data-name": "Path 52371",
    d: "M634.217,1131.96c0,2.03-5.986,6.795-28.051,10.978q-1.927.366-4.019.724c-21.845,3.739-50.917,5.8-81.862,5.8s-60.017-2.059-81.862-5.8q-2.093-.358-4.019-.724c-22.065-4.183-28.051-8.948-28.051-10.978,0-2.148,6.7-7.36,32.07-11.7,21.845-3.739,50.917-5.8,81.862-5.8s60.017,2.059,81.862,5.8c25.367,4.342,32.07,9.554,32.07,11.7",
    transform: "translate(-406.352 -1114.46)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52372",
    "data-name": "Path 52372",
    d: "M445.7,788.86c-84.636,0-153.246,11.732-153.246,26.2a4.337,4.337,0,0,0,.079.835l.788,1.963,10.055,25.028L324,894.2C352.787,904.793,396.614,911.3,445.7,911.3s92.916-6.5,121.707-17.094l20.616-51.316,10.055-25.028.788-1.963a4.364,4.364,0,0,0,.079-.835c0-14.47-68.609-26.2-153.246-26.2",
    transform: "translate(-191.509 -516.565)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48780",
    "data-name": "Group 48780",
    transform: "translate(104.284 275.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48779",
    "data-name": "Group 48779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48778",
    "data-name": "Group 48778",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52373",
    "data-name": "Path 52373",
    d: "M601.942,821.089c0,2.671-7.877,8.941-36.909,14.445q-2.535.481-5.288.953c-28.743,4.92-67,7.629-107.714,7.629s-78.97-2.709-107.714-7.629q-2.753-.472-5.288-.953c-29.033-5.5-36.909-11.774-36.909-14.445,0-2.827,8.82-9.684,42.2-15.4,28.744-4.92,67-7.629,107.714-7.629s78.97,2.709,107.714,7.629c33.378,5.714,42.2,12.571,42.2,15.4",
    transform: "translate(-302.12 -798.062)",
    fill: "#1e5a7c"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52374",
    "data-name": "Path 52374",
    d: "M353.9,374.483c-111.363,0-201.639,15.438-201.639,34.477a5.751,5.751,0,0,0,.1,1.1l1.037,2.583,13.231,32.931,27.126,67.521c37.883,13.933,95.55,22.492,160.141,22.492s122.258-8.559,160.141-22.492l27.126-67.521L554.4,412.642l1.037-2.583a5.753,5.753,0,0,0,.1-1.1c0-19.039-90.276-34.477-201.639-34.477",
    transform: "translate(-99.703 -245.22)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48783",
    "data-name": "Group 48783",
    transform: "translate(56.943 133.442)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48782",
    "data-name": "Group 48782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48781",
    "data-name": "Group 48781",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52375",
    "data-name": "Path 52375",
    d: "M559.473,416.888c0,3.515-10.364,11.764-48.565,19.007q-3.335.633-6.958,1.253c-37.82,6.473-88.153,10.038-141.728,10.038s-103.908-3.565-141.728-10.038q-3.623-.62-6.958-1.253c-38.2-7.242-48.565-15.492-48.565-19.007,0-3.719,11.605-12.742,55.523-20.26,37.82-6.474,88.153-10.038,141.728-10.038s103.908,3.565,141.728,10.038c43.918,7.518,55.523,16.54,55.523,20.26",
    transform: "translate(-164.97 -386.59)"
  }))))), /*#__PURE__*/React.createElement("line", {
    id: "Line_2205",
    "data-name": "Line 2205",
    x2: 395,
    transform: "translate(552.5 1353)",
    fill: "none",
    stroke: "#3eb6fb",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19219",
    "data-name": "Rectangle 19219",
    width: 394.503,
    height: 60.596,
    transform: "translate(236.943 1148.62)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "topA1",
    "data-name": "Group 48813",
    transform: "translate(-177.237 -65.668)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5144-4",
    "data-name": "Ellipse 5144",
    cx: 42.556,
    cy: 42.556,
    r: 42.556,
    transform: "translate(594.432 1139.879) rotate(-45)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52389-4",
    "data-name": "Path 52389",
    d: "M9.338,50.479A41.141,41.141,0,1,0,50.479,9.338,41.141,41.141,0,0,0,9.338,50.479",
    transform: "translate(604.136 1089.4)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52390-4",
    "data-name": "Path 52390",
    d: "M28.125,238.818H28.1a.435.435,0,0,1-.411-.457,38.6,38.6,0,0,1,.558-4.825.435.435,0,1,1,.855.155,37.834,37.834,0,0,0-.546,4.715.435.435,0,0,1-.434.412",
    transform: "translate(588.565 899.479)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52391-4",
    "data-name": "Path 52391",
    d: "M54.526,49.1a.435.435,0,0,1-.387-.63A38.251,38.251,0,0,1,88.451,27.343a38.718,38.718,0,0,1,6.929.624.434.434,0,1,1-.156.855,37.892,37.892,0,0,0-6.773-.609A37.387,37.387,0,0,0,54.915,48.861a.435.435,0,0,1-.388.239",
    transform: "translate(566.164 1074.123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48811-4",
    "data-name": "Group 48811",
    transform: "translate(620.691 1105.954)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48810-4",
    "data-name": "Group 48810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48809-4",
    "data-name": "Group 48809",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52392-4",
    "data-name": "Path 52392",
    d: "M126.6,91.78A34.821,34.821,0,1,1,91.781,56.959,34.82,34.82,0,0,1,126.6,91.78",
    transform: "translate(-56.96 -56.959)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52393-4",
    "data-name": "Path 52393",
    d: "M208.332,137.509c0,6.1,4.945,12.685,11.044,12.685s11.044-6.585,11.044-12.685-4.945-10.427-11.044-10.427-11.044,4.327-11.044,10.427",
    transform: "translate(435.297 989.498)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52394-4",
    "data-name": "Path 52394",
    d: "M144.708,305.986a6.5,6.5,0,0,0-4.165,7.878l1.117,4.118a6.526,6.526,0,0,0,6.3,4.818H174.92a6.526,6.526,0,0,0,6.216-4.537l1.451-4.535a6.519,6.519,0,0,0-3.939-8.112,45.576,45.576,0,0,0-15.778-2.779,57.45,57.45,0,0,0-18.163,3.149",
    transform: "translate(493.008 840.377)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "sum",
    values: "0,-24; 0,0; 0,26",
    keyTimes: "0; 0.35; 1",
    dur: "4s",
    begin: "0s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.42 0 1 1; 0 0 0.58 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    keyTimes: "0;0.25;0.90;1",
    dur: "4s",
    begin: "0s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.42 0 1 1; 0 0 1 1; 0.2 0 0.8 1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "topA2",
    "data-name": "Group 48816",
    transform: "translate(-258.584 -70.55)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5144-5",
    "data-name": "Ellipse 5144",
    cx: 26.748,
    cy: 26.748,
    r: 26.748,
    transform: "translate(594.432 1117.524) rotate(-45)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52389-5",
    "data-name": "Path 52389",
    d: "M9.338,35.2A25.859,25.859,0,1,0,35.2,9.338,25.859,25.859,0,0,0,9.338,35.2",
    transform: "translate(597.063 1082.327)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52390-5",
    "data-name": "Path 52390",
    d: "M27.963,236.723h-.015a.273.273,0,0,1-.259-.287,24.264,24.264,0,0,1,.351-3.033.273.273,0,1,1,.538.1,23.781,23.781,0,0,0-.343,2.964.273.273,0,0,1-.273.259",
    transform: "translate(580.459 879.807)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52391-5",
    "data-name": "Path 52391",
    d: "M54.365,41.018a.273.273,0,0,1-.244-.4A24.043,24.043,0,0,1,75.688,27.343a24.336,24.336,0,0,1,4.355.392.273.273,0,1,1-.1.537,23.817,23.817,0,0,0-4.257-.383A23.5,23.5,0,0,0,54.609,40.868a.273.273,0,0,1-.244.15",
    transform: "translate(556.572 1066.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48811-5",
    "data-name": "Group 48811",
    transform: "translate(610.937 1096.201)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48810-5",
    "data-name": "Group 48810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48809-5",
    "data-name": "Group 48809",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52392-5",
    "data-name": "Path 52392",
    d: "M100.733,78.846A21.887,21.887,0,1,1,78.847,56.959a21.886,21.886,0,0,1,21.887,21.887",
    transform: "translate(-56.96 -56.959)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52393-5",
    "data-name": "Path 52393",
    d: "M208.332,133.636c0,3.834,3.108,7.973,6.942,7.973s6.942-4.139,6.942-7.973a6.953,6.953,0,0,0-13.884,0",
    transform: "translate(417.023 975.798)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52394-5",
    "data-name": "Path 52394",
    d: "M143.075,304.816a4.085,4.085,0,0,0-2.618,4.952l.7,2.588a4.1,4.1,0,0,0,3.959,3.028h16.947a4.1,4.1,0,0,0,3.907-2.852l.912-2.85a4.1,4.1,0,0,0-2.476-5.1,28.648,28.648,0,0,0-9.917-1.747,36.11,36.11,0,0,0-11.416,1.979",
    transform: "translate(478.563 816.783)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "sum",
    values: "0,-24; 0,0; 0,22",
    keyTimes: "0; 0.35; 1",
    dur: "3.9s",
    begin: "1.02s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.42 0 1 1; 0 0 0.58 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    keyTimes: "0;0.25;0.86;1",
    dur: "3.9s",
    begin: "1.02s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.42 0 1 1; 0 0 1 1; 0.2 0 0.8 1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_52381",
    "data-name": "Path 52381",
    d: "M353.9,374.483c-111.363,0-201.639,15.438-201.639,34.477a5.751,5.751,0,0,0,.1,1.1l1.037,2.583,13.231,32.931,27.126,67.521c37.883,13.933,95.55,22.492,160.141,22.492s122.258-8.559,160.141-22.492l27.126-67.521L554.4,412.642l1.037-2.583a5.753,5.753,0,0,0,.1-1.1c0-19.039-90.276-34.477-201.639-34.477",
    transform: "translate(80.297 769.958)",
    fill: "#78849e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48782-2",
    "data-name": "Group 48782",
    transform: "translate(236.943 1148.62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48781-2",
    "data-name": "Group 48781",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52375-2",
    "data-name": "Path 52375",
    d: "M559.473,416.888c0,3.515-10.364,11.764-48.565,19.007q-3.335.633-6.958,1.253c-37.82,6.473-88.153,10.038-141.728,10.038s-103.908-3.565-141.728-10.038q-3.623-.62-6.958-1.253c-38.2-7.242-48.565-15.492-48.565-19.007,0-3.719,11.605-12.742,55.523-20.26,37.82-6.474,88.153-10.038,141.728-10.038s103.908,3.565,141.728,10.038c43.918,7.518,55.523,16.54,55.523,20.26",
    transform: "translate(-164.97 -386.59)",
    fill: "#3b414e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "topA3",
    "data-name": "Group 48812",
    transform: "translate(-177.237 54.697)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5144-6",
    "data-name": "Ellipse 5144",
    cx: 50.787,
    cy: 50.787,
    r: 50.787,
    transform: "translate(594.432 1151.52) rotate(-45)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52389-6",
    "data-name": "Path 52389",
    d: "M9.338,58.436a49.1,49.1,0,1,0,49.1-49.1,49.1,49.1,0,0,0-49.1,49.1",
    transform: "translate(607.819 1093.083)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52390-6",
    "data-name": "Path 52390",
    d: "M28.209,239.909h-.028a.519.519,0,0,1-.491-.545,46.068,46.068,0,0,1,.666-5.758.519.519,0,1,1,1.021.184,45.151,45.151,0,0,0-.651,5.627.519.519,0,0,1-.517.492",
    transform: "translate(592.786 909.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52391-6",
    "data-name": "Path 52391",
    d: "M54.61,53.308a.519.519,0,0,1-.462-.752A45.65,45.65,0,0,1,95.1,27.343a46.207,46.207,0,0,1,8.269.745.518.518,0,1,1-.186,1.02A45.222,45.222,0,0,0,95.1,28.38,44.618,44.618,0,0,0,55.074,53.023a.519.519,0,0,1-.464.285",
    transform: "translate(571.159 1078.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48811-6",
    "data-name": "Group 48811",
    transform: "translate(625.77 1111.033)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48810-6",
    "data-name": "Group 48810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48809-6",
    "data-name": "Group 48809",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52392-6",
    "data-name": "Path 52392",
    d: "M140.071,98.515A41.556,41.556,0,1,1,98.516,56.959a41.556,41.556,0,0,1,41.556,41.556",
    transform: "translate(-56.96 -56.959)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52393-6",
    "data-name": "Path 52393",
    d: "M208.332,139.526c0,7.28,5.9,15.138,13.181,15.138s13.181-7.859,13.181-15.138-5.9-12.444-13.181-12.444-13.181,5.164-13.181,12.444",
    transform: "translate(444.813 996.633)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52394-6",
    "data-name": "Path 52394",
    d: "M145.558,306.6a7.755,7.755,0,0,0-4.97,9.4l1.333,4.915a7.789,7.789,0,0,0,7.517,5.75h32.176a7.788,7.788,0,0,0,7.418-5.415l1.732-5.412a7.78,7.78,0,0,0-4.7-9.681,54.392,54.392,0,0,0-18.829-3.316,68.562,68.562,0,0,0-21.676,3.758",
    transform: "translate(500.531 852.663)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "sum",
    values: "0,-24; 0,0; 0,26",
    keyTimes: "0; 0.35; 1",
    dur: "4s",
    begin: "0.7s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.42 0 1 1; 0 0 0.58 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    keyTimes: "0;0.25;0.90;1",
    dur: "4s",
    begin: "0.7s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.42 0 1 1; 0 0 1 1; 0.2 0 0.8 1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_1",
    "data-name": "Exclusion 1",
    d: "M888.639-13178.9c-15.89,0-31.684-.523-46.944-1.555-14.913-1.009-29.428-2.511-43.142-4.466-13.536-1.929-26.366-4.311-38.134-7.078a276.72,276.72,0,0,1-31.92-9.393l-27.128-67.521-13.231-32.93-1.038-2.585a5.765,5.765,0,0,1-.1-1.1c0-2.339,1.378-4.677,4.1-6.948a45.01,45.01,0,0,1,11.749-6.472,146.508,146.508,0,0,1,18.591-5.855c7.214-1.826,15.5-3.543,24.622-5.1,18.509-3.165,40.074-5.651,64.094-7.39,24.855-1.8,51.263-2.709,78.488-2.709s53.633.911,78.488,2.709c24.02,1.738,45.584,4.225,64.093,7.39,9.124,1.56,17.407,3.276,24.621,5.1a146.5,146.5,0,0,1,18.59,5.855,45.009,45.009,0,0,1,11.749,6.472c2.718,2.271,4.1,4.609,4.1,6.948a5.768,5.768,0,0,1-.1,1.1l-1.034,2.585-13.231,32.93-27.128,67.521a276.758,276.758,0,0,1-31.92,9.393c-11.768,2.768-24.6,5.149-38.134,7.078-13.714,1.955-28.229,3.457-43.142,4.466C920.324-13179.423,904.529-13178.9,888.639-13178.9Zm0-156.923c-53.575,0-103.909,3.566-141.73,10.041-43.917,7.516-55.522,16.537-55.522,20.258,0,.677.385,1.821,2.216,3.435a32.823,32.823,0,0,0,7.741,4.671,108.138,108.138,0,0,0,14.9,5.37c6.773,1.972,14.748,3.832,23.7,5.53,2.237.424,4.578.847,6.957,1.256,37.825,6.473,88.159,10.037,141.73,10.037s103.9-3.564,141.727-10.037c2.426-.417,4.767-.839,6.96-1.256,8.955-1.7,16.93-3.559,23.7-5.53a108.132,108.132,0,0,0,14.9-5.37,32.827,32.827,0,0,0,7.741-4.671c1.011-.891,2.216-2.209,2.216-3.435,0-3.721-11.6-12.742-55.525-20.258C992.549-13332.256,942.216-13335.822,888.639-13335.822Z",
    transform: "translate(-453.999 14484.44)",
    fill: "#78849e",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "topA4",
    "data-name": "Group 48815",
    transform: "translate(-303.885 -17.127)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5144-7",
    "data-name": "Ellipse 5144",
    cx: 50.787,
    cy: 50.787,
    r: 50.787,
    transform: "translate(594.432 1151.52) rotate(-45)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52389-7",
    "data-name": "Path 52389",
    d: "M9.338,58.436a49.1,49.1,0,1,0,49.1-49.1,49.1,49.1,0,0,0-49.1,49.1",
    transform: "translate(607.819 1093.083)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52390-7",
    "data-name": "Path 52390",
    d: "M28.209,239.909h-.028a.519.519,0,0,1-.491-.545,46.068,46.068,0,0,1,.666-5.758.519.519,0,1,1,1.021.184,45.151,45.151,0,0,0-.651,5.627.519.519,0,0,1-.517.492",
    transform: "translate(592.786 909.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52391-7",
    "data-name": "Path 52391",
    d: "M54.61,53.308a.519.519,0,0,1-.462-.752A45.65,45.65,0,0,1,95.1,27.343a46.207,46.207,0,0,1,8.269.745.518.518,0,1,1-.186,1.02A45.222,45.222,0,0,0,95.1,28.38,44.618,44.618,0,0,0,55.074,53.023a.519.519,0,0,1-.464.285",
    transform: "translate(571.159 1078.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48811-7",
    "data-name": "Group 48811",
    transform: "translate(625.77 1111.033)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48810-7",
    "data-name": "Group 48810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48809-7",
    "data-name": "Group 48809",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52392-7",
    "data-name": "Path 52392",
    d: "M140.071,98.515A41.556,41.556,0,1,1,98.516,56.959a41.556,41.556,0,0,1,41.556,41.556",
    transform: "translate(-56.96 -56.959)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_52393-7",
    "data-name": "Path 52393",
    d: "M208.332,139.526c0,7.28,5.9,15.138,13.181,15.138s13.181-7.859,13.181-15.138-5.9-12.444-13.181-12.444-13.181,5.164-13.181,12.444",
    transform: "translate(444.813 996.633)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52394-7",
    "data-name": "Path 52394",
    d: "M145.558,306.6a7.755,7.755,0,0,0-4.97,9.4l1.333,4.915a7.789,7.789,0,0,0,7.517,5.75h32.176a7.788,7.788,0,0,0,7.418-5.415l1.732-5.412a7.78,7.78,0,0,0-4.7-9.681,54.392,54.392,0,0,0-18.829-3.316,68.562,68.562,0,0,0-21.676,3.758",
    transform: "translate(500.531 852.663)",
    fill: "#3eb6fb"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    additive: "sum",
    values: "0,-24; 0,0; 0,22",
    keyTimes: "0; 0.35; 1",
    dur: "4s",
    begin: "1.18s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.42 0 1 1; 0 0 0.58 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    keyTimes: "0;0.25;0.90;1",
    dur: "4s",
    begin: "1.18s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.42 0 1 1; 0 0 1 1; 0.2 0 0.8 1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48853",
    "data-name": "Group 48853",
    transform: "translate(345.243 1449.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52415",
    "data-name": "Path 52415",
    d: "M4.784,8.282,7.29,3.152l1.2,5.582ZM6.167,0,0,12.259l2.7.329,1.141-2.337,5.1.621.547,2.543,2.714.331L9.157.364Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48852",
    "data-name": "Group 48852",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48851",
    "data-name": "Group 48851",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52416",
    "data-name": "Path 52416",
    d: "M24.54,5.95a4.159,4.159,0,0,1,2.041-.277,4.469,4.469,0,0,1,2.3.871,4.548,4.548,0,0,1,1.5,1.99,5.915,5.915,0,0,1,.352,2.81,6.018,6.018,0,0,1-.883,2.708A4.643,4.643,0,0,1,28,15.758a4.374,4.374,0,0,1-2.427.436,4.148,4.148,0,0,1-1.933-.65,4.271,4.271,0,0,1-1.278-1.293l-.606,6.309-2.575-.247L20.624,5.268l2.575.247-.141,1.472A3.925,3.925,0,0,1,24.54,5.95m3.338,3.514a2.626,2.626,0,0,0-.9-1.116,2.67,2.67,0,0,0-1.3-.478,2.582,2.582,0,0,0-1.35.232,2.674,2.674,0,0,0-1.093.944,3.268,3.268,0,0,0-.531,1.563,3.266,3.266,0,0,0,.223,1.637,2.669,2.669,0,0,0,.893,1.135,2.61,2.61,0,0,0,2.649.245,2.742,2.742,0,0,0,1.094-.952,3.312,3.312,0,0,0,.533-1.583,3.222,3.222,0,0,0-.224-1.627",
    transform: "translate(-5.549 -1.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52417",
    "data-name": "Path 52417",
    d: "M42.112,7.5a4.173,4.173,0,0,1,2.034-.32A4.48,4.48,0,0,1,46.465,8,4.558,4.558,0,0,1,48,9.962a5.909,5.909,0,0,1,.411,2.8,6.014,6.014,0,0,1-.824,2.726,4.657,4.657,0,0,1-1.817,1.745,4.38,4.38,0,0,1-2.417.485,4.123,4.123,0,0,1-1.947-.608,4.25,4.25,0,0,1-1.3-1.266l-.473,6.321-2.58-.193L38.182,6.9l2.579.193-.11,1.474A3.934,3.934,0,0,1,42.112,7.5m3.411,3.443a2.613,2.613,0,0,0-.918-1.1,2.675,2.675,0,0,0-1.31-.451,2.588,2.588,0,0,0-1.344.261,2.672,2.672,0,0,0-1.073.967,3.26,3.26,0,0,0-.5,1.575,3.251,3.251,0,0,0,.257,1.632,2.667,2.667,0,0,0,.917,1.115,2.607,2.607,0,0,0,2.654.189,2.725,2.725,0,0,0,1.074-.976,3.3,3.3,0,0,0,.5-1.593,3.2,3.2,0,0,0-.259-1.622",
    transform: "translate(-10.72 -1.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19255",
    "data-name": "Rectangle 19255",
    width: 13.674,
    height: 2.586,
    transform: "matrix(0.061, -0.998, 0.998, 0.061, 39.288, 16.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52418",
    "data-name": "Path 52418",
    d: "M65.683,7.022l-.554,10.222L62.546,17.1,63.1,6.882ZM63.365,5.24a1.437,1.437,0,0,1-.394-1.1,1.438,1.438,0,0,1,.51-1.055A1.7,1.7,0,0,1,65.75,3.2a1.434,1.434,0,0,1,.394,1.1,1.436,1.436,0,0,1-.51,1.055,1.7,1.7,0,0,1-2.269-.123",
    transform: "translate(-18.096 -0.783)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52419",
    "data-name": "Path 52419",
    d: "M70.012,11.317a4.615,4.615,0,0,1,1.871-1.769,5.171,5.171,0,0,1,2.649-.542,5.04,5.04,0,0,1,3.106,1.086,4.634,4.634,0,0,1,1.556,2.74l-2.787-.12a2.046,2.046,0,0,0-.7-1.075,2.172,2.172,0,0,0-1.286-.434,2.131,2.131,0,0,0-1.787.727,3.551,3.551,0,0,0-.745,2.252,3.522,3.522,0,0,0,.549,2.289,2.134,2.134,0,0,0,1.719.878,1.961,1.961,0,0,0,2.109-1.314l2.788.12a4.72,4.72,0,0,1-1.794,2.568,4.949,4.949,0,0,1-3.18.842,5.175,5.175,0,0,1-2.594-.768,4.614,4.614,0,0,1-1.711-1.923,5.732,5.732,0,0,1-.527-2.806,5.743,5.743,0,0,1,.766-2.75",
    transform: "translate(-20.032 -2.604)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52420",
    "data-name": "Path 52420",
    d: "M85.607,11.926a4.536,4.536,0,0,1,1.733-1.8,4.476,4.476,0,0,1,2.391-.58,4.178,4.178,0,0,1,1.991.517,4.079,4.079,0,0,1,1.344,1.2l.04-1.459,2.6.072-.286,10.233-2.6-.072.041-1.5A3.851,3.851,0,0,1,91.453,19.7a4.209,4.209,0,0,1-2.035.414,4.339,4.339,0,0,1-2.336-.731,4.654,4.654,0,0,1-1.629-1.922,6.011,6.011,0,0,1-.541-2.8,5.921,5.921,0,0,1,.7-2.735m7.032,1.37a2.608,2.608,0,0,0-.968-1.062,2.679,2.679,0,0,0-1.338-.4,2.6,2.6,0,0,0-2.357,1.312,3.209,3.209,0,0,0-.423,1.587,3.32,3.32,0,0,0,.334,1.627,2.725,2.725,0,0,0,.967,1.09,2.536,2.536,0,0,0,1.31.406,2.672,2.672,0,0,0,1.359-.322,2.613,2.613,0,0,0,1.026-1.007,3.32,3.32,0,0,0,.415-1.605,3.324,3.324,0,0,0-.325-1.627",
    transform: "translate(-24.566 -2.761)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52421",
    "data-name": "Path 52421",
    d: "M112.161,11.172a4.419,4.419,0,0,1,1.085,3.239l-.077,6-2.587-.033.073-5.653a2.657,2.657,0,0,0-.586-1.883,2.16,2.16,0,0,0-1.655-.677,2.216,2.216,0,0,0-1.7.635,2.623,2.623,0,0,0-.642,1.867L106,20.323l-2.587-.033.132-10.236,2.587.033-.017,1.275a3.565,3.565,0,0,1,1.335-1.028,4.107,4.107,0,0,1,1.769-.356,3.948,3.948,0,0,1,2.942,1.193",
    transform: "translate(-29.92 -2.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52422",
    "data-name": "Path 52422",
    d: "M123.4,11.365l-.008,4.952a.978.978,0,0,0,.249.748,1.225,1.225,0,0,0,.84.233h1.2l0,2.18-1.626,0q-3.269,0-3.266-3.182l.008-4.934-1.22,0,0-2.125,1.22,0,0-2.532,2.605,0,0,2.531,2.291,0,0,2.125Z",
    transform: "translate(-34.595 -1.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52423",
    "data-name": "Path 52423",
    d: "M145.338,6.313l.03,2.088-3.436.049.154,10.808-2.587.037-.154-10.808-3.437.048-.03-2.088Z",
    transform: "translate(-39.313 -1.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52424",
    "data-name": "Path 52424",
    d: "M155.725,10.085a3.637,3.637,0,0,1,1.826-.509l.068,2.715-.683.018a2.618,2.618,0,0,0-1.824.619,2.64,2.64,0,0,0-.569,2.011l.129,5.1-2.587.065-.258-10.234,2.585-.065.041,1.589a3.639,3.639,0,0,1,1.27-1.308",
    transform: "translate(-43.927 -2.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52425",
    "data-name": "Path 52425",
    d: "M162.135,11.9a4.536,4.536,0,0,1,1.611-1.91,4.474,4.474,0,0,1,2.347-.736,4.172,4.172,0,0,1,2.021.386,4.083,4.083,0,0,1,1.42,1.111l-.055-1.458,2.6-.1.388,10.229-2.6.1-.057-1.5a3.862,3.862,0,0,1-1.33,1.243,4.222,4.222,0,0,1-2,.547,4.347,4.347,0,0,1-2.379-.575,4.652,4.652,0,0,1-1.751-1.811,6.015,6.015,0,0,1-.724-2.755,5.931,5.931,0,0,1,.514-2.774m7.107.9a2.606,2.606,0,0,0-1.036-1,2.669,2.669,0,0,0-1.362-.309,2.613,2.613,0,0,0-1.316.4,2.645,2.645,0,0,0-.949,1.062,3.209,3.209,0,0,0-.318,1.611,3.317,3.317,0,0,0,.44,1.6,2.728,2.728,0,0,0,1.037,1.024,2.533,2.533,0,0,0,1.335.319,2.67,2.67,0,0,0,1.334-.411,2.607,2.607,0,0,0,.958-1.072,3.308,3.308,0,0,0,.308-1.63,3.316,3.316,0,0,0-.43-1.6",
    transform: "translate(-46.759 -2.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52426",
    "data-name": "Path 52426",
    d: "M179.739,11.194a4.617,4.617,0,0,1,1.691-1.941,5.2,5.2,0,0,1,2.585-.8,5.051,5.051,0,0,1,3.2.782,4.632,4.632,0,0,1,1.813,2.576l-2.785.15a2.044,2.044,0,0,0-.8-1,2.176,2.176,0,0,0-1.322-.308,2.134,2.134,0,0,0-1.709.9,3.555,3.555,0,0,0-.523,2.313,3.521,3.521,0,0,0,.768,2.226,2.134,2.134,0,0,0,1.8.709,1.962,1.962,0,0,0,1.972-1.513l2.786-.149a4.719,4.719,0,0,1-1.537,2.728,4.954,4.954,0,0,1-3.084,1.146,5.178,5.178,0,0,1-2.655-.514,4.62,4.62,0,0,1-1.889-1.749,5.741,5.741,0,0,1-.8-2.742,5.744,5.744,0,0,1,.5-2.812",
    transform: "translate(-51.856 -2.444)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52427",
    "data-name": "Path 52427",
    d: "M202.012,16.484l-3.769-4.108.3,4.35-2.58.18-.952-13.641,2.581-.18.542,7.76,3.126-4.57,3.355-.234-4.14,5.437,4.889,4.771Z",
    transform: "translate(-56.422 -0.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52428",
    "data-name": "Path 52428",
    d: "M210.252,3.632a1.437,1.437,0,0,1-.54-1.04,1.433,1.433,0,0,1,.362-1.114,1.7,1.7,0,0,1,2.265-.187,1.439,1.439,0,0,1,.54,1.04,1.436,1.436,0,0,1-.362,1.114,1.7,1.7,0,0,1-2.265.187m2.539,1.45.842,10.2-2.578.212-.841-10.2Z",
    transform: "translate(-60.672 -0.273)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52429",
    "data-name": "Path 52429",
    d: "M226.251,6.358a4.426,4.426,0,0,1,1.436,3.1l.583,5.977-2.574.252-.55-5.627a2.657,2.657,0,0,0-.789-1.808,2.159,2.159,0,0,0-1.718-.491,2.209,2.209,0,0,0-1.619.817,2.626,2.626,0,0,0-.434,1.927l.549,5.627-2.575.252-.995-10.188,2.575-.252.124,1.269a3.563,3.563,0,0,1,1.213-1.167A4.083,4.083,0,0,1,223.2,5.5a3.944,3.944,0,0,1,3.055.862",
    transform: "translate(-62.946 -1.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52430",
    "data-name": "Path 52430",
    d: "M240.506,3.855a3.706,3.706,0,0,1,1.5,1L241.828,3.4l2.586-.316,1.254,10.233a5.5,5.5,0,0,1-.259,2.591,4.249,4.249,0,0,1-1.49,1.971,5.5,5.5,0,0,1-2.671.989,5.92,5.92,0,0,1-3.673-.574,3.768,3.768,0,0,1-1.905-2.559l2.549-.312a1.908,1.908,0,0,0,1.007,1,3.063,3.063,0,0,0,1.674.214,2.534,2.534,0,0,0,1.734-.893,2.711,2.711,0,0,0,.448-2.112l-.194-1.576a3.939,3.939,0,0,1-1.22,1.36,4.106,4.106,0,0,1-1.931.72,4.392,4.392,0,0,1-2.428-.372,4.631,4.631,0,0,1-1.907-1.656,6.026,6.026,0,0,1-.953-2.686,5.92,5.92,0,0,1,.28-2.808,4.532,4.532,0,0,1,1.444-2.038,4.471,4.471,0,0,1,2.278-.931,4.3,4.3,0,0,1,2.055.2m1.382,3.069a2.6,2.6,0,0,0-1.116-.905,2.668,2.668,0,0,0-1.383-.194,2.6,2.6,0,0,0-2.134,1.649,3.206,3.206,0,0,0-.181,1.632,3.323,3.323,0,0,0,.572,1.559,2.722,2.722,0,0,0,1.12.932,2.526,2.526,0,0,0,1.357.206,2.666,2.666,0,0,0,1.295-.522,2.606,2.606,0,0,0,.864-1.148,3.321,3.321,0,0,0,.17-1.651,3.313,3.313,0,0,0-.563-1.559",
    transform: "translate(-67.816 -0.893)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48855",
    "data-name": "Group 48855",
    transform: "translate(387.004 1252.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48854",
    "data-name": "Group 48854",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52431",
    "data-name": "Path 52431",
    d: "M2.2,13.676A3.982,3.982,0,0,1,.556,12.27,3.5,3.5,0,0,1,0,10.193l2.77.123A1.788,1.788,0,0,0,3.277,11.6a2,2,0,0,0,1.373.524,2.146,2.146,0,0,0,1.441-.371,1.414,1.414,0,0,0,.567-1.111,1.314,1.314,0,0,0-.309-.957,2.451,2.451,0,0,0-.851-.62,14.427,14.427,0,0,0-1.428-.536,15.358,15.358,0,0,1-2.007-.82,3.568,3.568,0,0,1-1.3-1.15A3.1,3.1,0,0,1,.289,4.583,3.489,3.489,0,0,1,.95,2.615,3.648,3.648,0,0,1,2.614,1.386,5.842,5.842,0,0,1,5,1.039a5.128,5.128,0,0,1,3.2,1.114A3.6,3.6,0,0,1,9.448,4.918L6.6,4.791a1.479,1.479,0,0,0-.513-1.124,2.128,2.128,0,0,0-1.375-.5A1.8,1.8,0,0,0,3.491,3.5a1.4,1.4,0,0,0-.5,1.106,1.164,1.164,0,0,0,.3.874,2.612,2.612,0,0,0,.824.592q.5.235,1.409.553a15.058,15.058,0,0,1,2.016.829A3.7,3.7,0,0,1,8.857,8.628a3.085,3.085,0,0,1,.486,1.964,3.652,3.652,0,0,1-.621,1.9A3.784,3.784,0,0,1,7.09,13.83a5.363,5.363,0,0,1-2.478.416,6.122,6.122,0,0,1-2.407-.57",
    transform: "translate(0 -0.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52432",
    "data-name": "Path 52432",
    d: "M17.857,15.237a4.722,4.722,0,0,1-1.8-1.912,5.56,5.56,0,0,1-.592-2.791,5.447,5.447,0,0,1,.775-2.75,4.816,4.816,0,0,1,1.948-1.8,5.8,5.8,0,0,1,5.356.159,4.813,4.813,0,0,1,1.838,1.912,5.447,5.447,0,0,1,.61,2.792A5.335,5.335,0,0,1,25.2,13.6a4.927,4.927,0,0,1-1.976,1.8,5.58,5.58,0,0,1-2.725.576,5.388,5.388,0,0,1-2.64-.735m4.038-1.821a2.492,2.492,0,0,0,1.018-1,3.452,3.452,0,0,0,.419-1.652,3.085,3.085,0,0,0-.7-2.267,2.525,2.525,0,0,0-1.851-.841,2.464,2.464,0,0,0-1.88.73,3.129,3.129,0,0,0-.814,2.222,3.173,3.173,0,0,0,.662,2.265,2.4,2.4,0,0,0,1.814.84,2.7,2.7,0,0,0,1.331-.3",
    transform: "translate(-4.473 -1.564)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52433",
    "data-name": "Path 52433",
    d: "M42.705,6.064,42.552,16.3l-2.605-.039.02-1.293a3.414,3.414,0,0,1-1.318,1.025,4.049,4.049,0,0,1-1.752.352,4.349,4.349,0,0,1-2.117-.54,3.58,3.58,0,0,1-1.428-1.519,4.947,4.947,0,0,1-.492-2.364l.09-6,2.587.039-.085,5.634a2.657,2.657,0,0,0,.581,1.885,2.16,2.16,0,0,0,1.653.681,2.186,2.186,0,0,0,1.691-.63,2.657,2.657,0,0,0,.638-1.866L40.1,6.025Z",
    transform: "translate(-9.507 -1.712)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52434",
    "data-name": "Path 52434",
    d: "M54.111,6.411a3.616,3.616,0,0,1,1.84-.456l-.009,2.716-.684,0a2.618,2.618,0,0,0-1.841.566,2.638,2.638,0,0,0-.625,1.993l-.018,5.1-2.587-.009.035-10.236,2.588.009L52.8,7.681a3.644,3.644,0,0,1,1.307-1.271",
    transform: "translate(-14.52 -1.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52435",
    "data-name": "Path 52435",
    d: "M60.414,8.422a4.633,4.633,0,0,1,1.779-1.861,5.182,5.182,0,0,1,2.618-.675,5.047,5.047,0,0,1,3.158.927,4.632,4.632,0,0,1,1.692,2.658l-2.79.021a2.04,2.04,0,0,0-.757-1.038,2.175,2.175,0,0,0-1.3-.37,2.134,2.134,0,0,0-1.749.817,3.553,3.553,0,0,0-.63,2.287,3.525,3.525,0,0,0,.663,2.259,2.137,2.137,0,0,0,1.762.79,1.961,1.961,0,0,0,2.04-1.419l2.79-.021a4.732,4.732,0,0,1-1.662,2.656,4.967,4.967,0,0,1-3.134,1,5.181,5.181,0,0,1-2.628-.637,4.614,4.614,0,0,1-1.807-1.834,5.743,5.743,0,0,1-.668-2.776,5.739,5.739,0,0,1,.626-2.786",
    transform: "translate(-17.298 -1.703)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52436",
    "data-name": "Path 52436",
    d: "M76.272,2.615A1.438,1.438,0,0,1,75.8,1.543,1.439,1.439,0,0,1,76.236.454,1.7,1.7,0,0,1,78.508.415a1.437,1.437,0,0,1,.471,1.073,1.436,1.436,0,0,1-.434,1.089,1.705,1.705,0,0,1-2.273.038m2.44,1.613.176,10.234-2.587.045L76.125,4.272Z",
    transform: "translate(-21.931 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52437",
    "data-name": "Path 52437",
    d: "M92.1,6.538a4.424,4.424,0,0,1,1.217,3.191l.166,6L90.9,15.8l-.157-5.652a2.654,2.654,0,0,0-.662-1.858,2.161,2.161,0,0,0-1.68-.61,2.215,2.215,0,0,0-1.672.7,2.625,2.625,0,0,0-.566,1.892l.156,5.652L83.731,16,83.446,5.771,86.032,5.7l.036,1.275a3.567,3.567,0,0,1,1.291-1.08,4.091,4.091,0,0,1,1.754-.428A3.943,3.943,0,0,1,92.1,6.538",
    transform: "translate(-24.143 -1.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52438",
    "data-name": "Path 52438",
    d: "M106.378,5.241A3.727,3.727,0,0,1,107.8,6.353L107.732,4.9l2.6-.114.451,10.3a5.506,5.506,0,0,1-.462,2.563,4.26,4.26,0,0,1-1.639,1.847,5.494,5.494,0,0,1-2.74.776,5.928,5.928,0,0,1-3.617-.858,3.77,3.77,0,0,1-1.7-2.7l2.566-.112a1.913,1.913,0,0,0,.926,1.079,3.053,3.053,0,0,0,1.652.343,2.526,2.526,0,0,0,1.8-.753,2.7,2.7,0,0,0,.612-2.07l-.069-1.588a3.932,3.932,0,0,1-1.323,1.26,4.109,4.109,0,0,1-1.982.568,4.4,4.4,0,0,1-2.392-.561,4.635,4.635,0,0,1-1.771-1.8,6.014,6.014,0,0,1-.74-2.751,5.932,5.932,0,0,1,.5-2.778A4.538,4.538,0,0,1,102,5.627a4.492,4.492,0,0,1,2.345-.75,4.3,4.3,0,0,1,2.031.365m1.138,3.169a2.609,2.609,0,0,0-1.042-.991,2.671,2.671,0,0,0-1.364-.3,2.615,2.615,0,0,0-1.313.409,2.647,2.647,0,0,0-.943,1.068,3.2,3.2,0,0,0-.308,1.613,3.316,3.316,0,0,0,.449,1.6,2.726,2.726,0,0,0,1.043,1.018,2.533,2.533,0,0,0,1.336.311,2.663,2.663,0,0,0,1.332-.418,2.6,2.6,0,0,0,.952-1.077,3.315,3.315,0,0,0,.3-1.632,3.321,3.321,0,0,0-.44-1.6",
    transform: "translate(-28.903 -1.383)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48866",
    "data-name": "Group 48866",
    transform: "translate(364.409 1364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48865",
    "data-name": "Group 48865",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52474",
    "data-name": "Path 52474",
    d: "M9.877,6.943A3.759,3.759,0,0,1,8.155,8.328a5.831,5.831,0,0,1-2.787.347L3.12,8.488l-.43,5.151L0,13.414,1.119,0l4.94.412a5.986,5.986,0,0,1,2.606.759,3.762,3.762,0,0,1,1.52,1.617,4.181,4.181,0,0,1,.37,2.179,4.2,4.2,0,0,1-.678,1.975m-2.747-.82a1.886,1.886,0,0,0,.658-1.386q.164-1.96-2.028-2.144L3.626,2.415,3.3,6.317l2.133.178a2.335,2.335,0,0,0,1.695-.372",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52475",
    "data-name": "Path 52475",
    d: "M17.77,15.328a4.925,4.925,0,0,1-1.807-2.061,5.8,5.8,0,0,1-.514-2.932A5.685,5.685,0,0,1,16.36,7.5a5.03,5.03,0,0,1,2.1-1.805,6.053,6.053,0,0,1,5.581.365,5.028,5.028,0,0,1,1.846,2.063,5.692,5.692,0,0,1,.533,2.934,5.58,5.58,0,0,1-.93,2.838,5.141,5.141,0,0,1-2.127,1.8,5.831,5.831,0,0,1-2.865.5,5.619,5.619,0,0,1-2.727-.864m4.28-1.749a2.587,2.587,0,0,0,1.1-1,3.592,3.592,0,0,0,.5-1.706A3.216,3.216,0,0,0,23,8.481a2.631,2.631,0,0,0-1.9-.946,2.569,2.569,0,0,0-1.988.691,3.264,3.264,0,0,0-.932,2.287A3.315,3.315,0,0,0,18.79,12.9a2.507,2.507,0,0,0,1.861.943,2.81,2.81,0,0,0,1.4-.266",
    transform: "translate(-3.986 -1.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52476",
    "data-name": "Path 52476",
    d: "M32.826,7.361a4.658,4.658,0,0,1,4.372-2.4,4.539,4.539,0,0,1,1.963.548,3.961,3.961,0,0,1,1.444,1.276l.244-5.067,2.735.132L42.9,16.109l-2.735-.132L40.24,14.4a3.648,3.648,0,0,1-1.467,1.2,4.406,4.406,0,0,1-2.123.381,4.588,4.588,0,0,1-2.433-.812,4.844,4.844,0,0,1-1.668-2.04,6.287,6.287,0,0,1-.506-2.93,6.186,6.186,0,0,1,.783-2.839m7.309,1.578a2.713,2.713,0,0,0-.988-1.128,2.771,2.771,0,0,0-1.388-.444,2.726,2.726,0,0,0-1.4.3,2.76,2.76,0,0,0-1.082,1.019,3.36,3.36,0,0,0-.475,1.647,3.461,3.461,0,0,0,.314,1.705,2.844,2.844,0,0,0,.987,1.157,2.646,2.646,0,0,0,1.359.452,2.792,2.792,0,0,0,1.424-.308,2.73,2.73,0,0,0,1.092-1.029,3.465,3.465,0,0,0,.466-1.667,3.455,3.455,0,0,0-.3-1.7",
    transform: "translate(-8.273 -0.445)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52477",
    "data-name": "Path 52477",
    d: "M63.555,16.978l-2.829-5.323-1.273-.034-.14,5.244-2.7-.072.358-13.456,5.051.134a5.9,5.9,0,0,1,2.646.62,3.843,3.843,0,0,1,1.609,1.529,4.051,4.051,0,0,1,.493,2.107A3.889,3.889,0,0,1,63.6,11.521l3.074,5.541ZM59.508,9.6l2.256.06a2.254,2.254,0,0,0,1.653-.486A1.975,1.975,0,0,0,64,7.711a1.886,1.886,0,0,0-.5-1.451,2.307,2.307,0,0,0-1.624-.555l-2.256-.06Z",
    transform: "translate(-14.622 -0.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52478",
    "data-name": "Path 52478",
    d: "M83.1,13.73l-7.81-.1a2.655,2.655,0,0,0,.788,1.822,2.493,2.493,0,0,0,1.746.678,2.2,2.2,0,0,0,2.157-1.265l2.911.036a4.855,4.855,0,0,1-1.805,2.514,5.174,5.174,0,0,1-3.233.953,5.569,5.569,0,0,1-2.758-.719,4.807,4.807,0,0,1-1.885-1.961,5.93,5.93,0,0,1-.648-2.9,6.044,6.044,0,0,1,.711-2.9,4.7,4.7,0,0,1,1.914-1.9,6.066,6.066,0,0,1,5.524.05,4.612,4.612,0,0,1,1.847,1.885,5.631,5.631,0,0,1,.631,2.775,6.379,6.379,0,0,1-.09,1.041m-2.7-1.847a2.143,2.143,0,0,0-.731-1.677,2.673,2.673,0,0,0-1.786-.65,2.456,2.456,0,0,0-1.695.587,2.668,2.668,0,0,0-.86,1.677Z",
    transform: "translate(-18.741 -1.895)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52479",
    "data-name": "Path 52479",
    d: "M89.293,10.051A4.825,4.825,0,0,1,91.161,8.12,5.414,5.414,0,0,1,93.9,7.432a5.262,5.262,0,0,1,3.29.989,4.829,4.829,0,0,1,1.748,2.784l-2.912,0a2.129,2.129,0,0,0-.783-1.089,2.267,2.267,0,0,0-1.36-.393,2.222,2.222,0,0,0-1.831.841,3.713,3.713,0,0,0-.672,2.382,3.679,3.679,0,0,0,.679,2.362,2.227,2.227,0,0,0,1.833.837,2.047,2.047,0,0,0,2.138-1.469l2.913,0a4.93,4.93,0,0,1-1.752,2.76,5.17,5.17,0,0,1-3.277,1.027,5.425,5.425,0,0,1-2.739-.681A4.823,4.823,0,0,1,89.3,15.856a5.985,5.985,0,0,1-.679-2.9,5.993,5.993,0,0,1,.671-2.9",
    transform: "translate(-22.889 -1.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52480",
    "data-name": "Path 52480",
    d: "M109.193,7.827a3.786,3.786,0,0,1,1.913-.5l.033,2.835-.714.007a2.738,2.738,0,0,0-1.912.621,2.756,2.756,0,0,0-.622,2.09l.062,5.322-2.7.032L105.13,7.547l2.7-.032.019,1.658a3.794,3.794,0,0,1,1.344-1.346",
    transform: "translate(-27.152 -1.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52481",
    "data-name": "Path 52481",
    d: "M125.634,7.181l.252,10.681-2.718.064-.032-1.349A3.566,3.566,0,0,1,121.8,17.7a4.221,4.221,0,0,1-1.812.438,4.53,4.53,0,0,1-2.23-.478,3.738,3.738,0,0,1-1.551-1.526,5.153,5.153,0,0,1-.607-2.445l-.148-6.266,2.7-.064.139,5.88a2.765,2.765,0,0,0,.682,1.942,2.249,2.249,0,0,0,1.751.644,2.279,2.279,0,0,0,1.739-.725,2.772,2.772,0,0,0,.59-1.972l-.139-5.88Z",
    transform: "translate(-29.819 -1.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52482",
    "data-name": "Path 52482",
    d: "M132.7,3.761a1.5,1.5,0,0,1-.511-1.111,1.5,1.5,0,0,1,.434-1.144,1.778,1.778,0,0,1,2.37-.081,1.5,1.5,0,0,1,.512,1.111,1.5,1.5,0,0,1-.433,1.144,1.779,1.779,0,0,1-2.371.082M135.272,5.4l.368,10.678-2.7.093-.368-10.677Z",
    transform: "translate(-34.14 -0.261)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52483",
    "data-name": "Path 52483",
    d: "M142.807,7.913l.218,5.164a1.021,1.021,0,0,0,.293.769,1.279,1.279,0,0,0,.888.2L145.458,14l.1,2.273-1.7.072q-3.41.145-3.551-3.169l-.219-5.145-1.271.054-.094-2.216L140,5.813l-.112-2.64,2.717-.115.111,2.64,2.39-.1.093,2.216Z",
    transform: "translate(-35.829 -0.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52484",
    "data-name": "Path 52484",
    d: "M149.854,3.052a1.5,1.5,0,0,1-.529-1.1A1.5,1.5,0,0,1,149.74.8a1.778,1.778,0,0,1,2.369-.121,1.5,1.5,0,0,1,.529,1.1,1.5,1.5,0,0,1-.414,1.151,1.782,1.782,0,0,1-2.37.12m2.6,1.6L153,15.318l-2.7.136-.542-10.67Z",
    transform: "translate(-38.566 -0.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52485",
    "data-name": "Path 52485",
    d: "M166.118,6.294A4.616,4.616,0,0,1,167.5,9.579l.394,6.254L165.2,16l-.371-5.89a2.774,2.774,0,0,0-.759-1.914,2.25,2.25,0,0,0-1.775-.573,2.308,2.308,0,0,0-1.719.794,2.745,2.745,0,0,0-.521,1.995l.371,5.889-2.695.17-.671-10.662,2.695-.17.083,1.328A3.732,3.732,0,0,1,161.149,5.8a4.258,4.258,0,0,1,1.814-.51,4.118,4.118,0,0,1,3.155,1.009",
    transform: "translate(-40.566 -1.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52486",
    "data-name": "Path 52486",
    d: "M180.32,4.377a3.884,3.884,0,0,1,1.523,1.1l-.125-1.519,2.711-.223.883,10.725a5.745,5.745,0,0,1-.379,2.692,4.44,4.44,0,0,1-1.635,1.992,5.739,5.739,0,0,1-2.827.92,6.178,6.178,0,0,1-3.807-.751,3.928,3.928,0,0,1-1.88-2.747l2.671-.22a1.994,1.994,0,0,0,1.009,1.088,3.179,3.179,0,0,0,1.736.291,2.641,2.641,0,0,0,1.845-.857,2.831,2.831,0,0,0,.556-2.184l-.136-1.653a4.1,4.1,0,0,1-1.328,1.367,4.289,4.289,0,0,1-2.045.671,4.581,4.581,0,0,1-2.517-.49,4.83,4.83,0,0,1-1.919-1.805,6.287,6.287,0,0,1-.883-2.839,6.191,6.191,0,0,1,.408-2.917,4.727,4.727,0,0,1,1.592-2.066,4.673,4.673,0,0,1,2.414-.877,4.5,4.5,0,0,1,2.133.3m1.314,3.259a2.724,2.724,0,0,0-1.127-.991,2.8,2.8,0,0,0-1.433-.26,2.739,2.739,0,0,0-1.354.48,2.767,2.767,0,0,0-.941,1.151,3.365,3.365,0,0,0-.257,1.695,3.463,3.463,0,0,0,.533,1.649,2.829,2.829,0,0,0,1.129,1.02,2.651,2.651,0,0,0,1.406.272,2.8,2.8,0,0,0,1.372-.49A2.73,2.73,0,0,0,181.91,11a3.464,3.464,0,0,0,.246-1.713,3.473,3.473,0,0,0-.522-1.65",
    transform: "translate(-44.874 -0.965)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImplementation);
export default __webpack_public_path__ + "static/media/implementation.24a16c637ccadedbfc5434e958d34db4.svg";
export { ForwardRef as ReactComponent };